import './App.css';
import Header from './header';
import Main from './Main';

function App() {
  return (
    <div className="App  h-[200vh]">
      <Header />
      <Main />

    </div>
  );
}

export default App;
